import List                    from '@/components/list/List';
import NewsletterModel         from '@/models/services/notification/NewsletterModel';
import NewslettersListRow      from '@/pages/Newsletters/components/NewslettersListRow';
import SubscriptionModel       from '@/models/services/notification/SubscriptionModel';
import SubscriptionStatusModel from '@/models/services/notification/SubscriptionStatusModel';
import useApiCollection        from '@widesk-core/hooks/useApiCollection';
import usePagedCollection      from '@widesk-core/hooks/usePagedCollection';
import { ModalData }           from '@/components/modal/Modal';

interface INewslettersListBoxProps {
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewslettersListBox = (props: INewslettersListBoxProps) => {

	const { setModalData, setModalIsOpen } = props;

	const newsletterCollection = usePagedCollection(NewsletterModel);
	const subscriptionCollection = useApiCollection(SubscriptionModel);
	const subscriptionStatusCollection = useApiCollection(SubscriptionStatusModel);

	return (
		<List
			afterFetch={async () => {
				await Promise.all([
					subscriptionStatusCollection.list(),
					subscriptionCollection.list(),
				]);
				await subscriptionCollection.whenIsLoaded(m => m.subscriptionStatus);
			}}
			collection={newsletterCollection}
			renderRow={(model) => (
				<NewslettersListRow 
					newsletter={model} 
					subscriptionCollection={subscriptionCollection} 
					subscriptionStatusCollection={subscriptionStatusCollection} 
					setModalData={setModalData}
					setModalIsOpen={setModalIsOpen}
				/>
			)}
			options={{
				itemsMargin: '10px 0px 10px 0px',
				itemsPadding: '10px',
				padding: '0px 10px 0px 10px',
				withPagination: false,
				withSeparators: true,
				maxWidth: '500px'
			}}
			sort={{ name: 'id', way: 'asc' }}
		/>
	)
}

export default NewslettersListBox